import { render, staticRenderFns } from "./DisplayLocation.vue?vue&type=template&id=dfb4dc78&"
import script from "./DisplayLocation.vue?vue&type=script&lang=js&"
export * from "./DisplayLocation.vue?vue&type=script&lang=js&"
import style0 from "./DisplayLocation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports